<template>
  <div class="av-participant-portal-help-message pt-30 pb-30">
    <div class="text-center">
      <button class="btn activity-help-btn" data-toggle="modal" data-target="#activityHelpModal">
        Help
      </button>
      <!-- v-translate:need_help="lang" -->
    </div>
    <div class="modal fade" id="activityHelpModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content p-30">
          <p class="activity-help-text text-center"><b>Help</b></p>
          <p class="activity-help-text m-0" v-html="helpContent"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["helpContent", "lang"]
};
</script>

<style lang="scss" scoped>
.av-participant-portal-help-message {
  .activity-help-btn {
    width: auto;
    height: 31px;
    border-radius: 10px;
    border: solid 1px #979797;
    background-color: #ffffff;
    text-align: center;
    padding: 1px 20px;
    color: #83c6a8;
    font-size: 14px;
    font-weight: 500;
  }
  .activity-help-text {
    font-family: Roboto;
    font-size: 16px;
    font-weight: normal;
    line-height: 1.38;
    color: #000000;
  }
}
</style>
